<template>
    <div>  
        <template v-if="text.type == 'text'">
            <!-- <span class="glyphicon glyphicon-sort" style="float:left;padding: 5px;cursor: grab"></span>  -->
            <div class="message" style="margin-bottom: 10px;float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;" >
                <div style="font-size: 12px;color:black">
                    <template >
                        <div style="padding: 5px 8px 6px;background-color:#F1F0F0">
                            <textarea ref="answer" class="form-control" placeholder="Answer" @keyup="resizeTextarea" v-model="text.value"  name="answer" data-vv-as="Answer" v-validate="'required'" style="resize: none"></textarea>
                            <div class="row">
                                <div class="col-xs-12 text-left">
                                    <a href="javascript:void(0);" @click="showEmoji = !showEmoji;showPrefill = false"><img src="/static/img/assets/facebook_ui/Expression.png" alt=""></a>
                                    <intent-prefill @addIntentPrefill="addIntentPrefill"></intent-prefill>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- <template >
                        <div style="padding: 5px 8px 6px;background-color:#F1F0F0" @click="isEdit = true">
                            <span style="line-height:15.36px;">
                                <template v-if="text.value != '' && text !=null">
                                    <specialtext :text="text.value"></specialtext>
                                </template>
                                <template v-else>Message</template>
                                <a href="javascript:void(0);" style="display:inline-block">
                                    <span class="glyphicon glyphicon-pencil" ></span>
                                </a>
                            </span>
                        </div>
                    </template> -->
                </div>
            </div>
            <a href="javascript:void(0);" @click="$emit('onDelete')" style="float:left;padding: 5px" >
            <span class="glyphicon glyphicon-remove" ></span>
            </a>
        </template>
        <template v-else-if="text.type == 'image'">
            <!-- <span class="glyphicon glyphicon-sort" style="float:left;padding: 5px;cursor: grab"></span>  -->
            <div class="message" style="margin-bottom: 10px;float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;">
                    <uploadfile v-model="text.value" :height="181" ></uploadfile>
                <div style="font-size: 12px;color:black">
                </div>
            </div>
            <a href="javascript:void(0);" @click="$emit('onDelete')" style="float:left;padding: 5px" >
            <span class="glyphicon glyphicon-remove" ></span>
            </a>
        </template>
        <div class="clearfix"></div>

        <modal v-show="showEmoji" @close="showEmoji = false">
            <div slot="body">
                <picker  @select="addEmoji" color="#EF3753" :showSkinTones="false" :showPreview="false" style="z-index: 300;margin-bottom: 30px;width:100%"/>       
            </div>

            <div slot="footer">

            </div>
        </modal>

    </div>
</template>

<script>
import IntentPrefill from './IntentPrefill'
import { Picker } from 'emoji-mart-vue'
import Modal from '@/components/elements/Modal'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'

    export default {
        props: ['value'],
        data: function(){
            return {
                type: '',
                text: this.value,
                showEmoji: false,
                showPrefill: false,
            }
        },
        components: {
			IntentPrefill,
            Picker,
            Modal,
            specialtext,
            uploadfile
        },
        created: function(){
            // this.text = Object.assign({},this.value)
            this.text = this.value
            
        },
        mounted: function(){
            this.resizeTextarea()
        },
        methods: {
			addIntentPrefill: function(prefill){
                var vm = this
                let cursorPosition = this.$refs.answer.selectionStart
                vm.text.value = [vm.text.value.slice(0, cursorPosition), '{' + prefill + '}' , vm.text.value.slice(cursorPosition)].join('');
                vm.showPrefill = false
			},
			addEmoji: function(emoji){
                var vm = this
                let cursorPosition = this.$refs.answer.selectionStart
                vm.text.value = [vm.text.value.slice(0, cursorPosition), emoji.native , vm.text.value.slice(cursorPosition)].join('');
                vm.showEmoji = false
            },
            onSave: function(){
                var vm = this
                vm.isEdit = false
                vm.$emit('onSave',vm.text)
            },
            resizeTextarea: function(){
                this.$refs.answer.style.height = "1px";
                this.$refs.answer.style.height = (12+this.$refs.answer.scrollHeight)+"px";
            }
        },
        watch: {
            value: function(){
                // this.text = Object.assign({},this.value)
                this.text = this.value
            },
            'text': function(){
                this.$emit('input',this.text)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentText.vue